<app-header></app-header>
<div class="content_wrapper">
    <div class="add_user">
        <div class="col-md-8">
            <div class="add_form_sec">
                <h4>Add User</h4>
                <form [formGroup]="form" (ngSubmit)="add_user()">
                    <div class="form-group">
                        <label for="username">Contact Name</label>
                        <input type="text" id="first_name" name="first_name" class="form-control" formControlName="str_first_name">
                        <span class="error_message" *ngIf="err.str_first_name">{{err.str_first_name}}</span>
                    </div>
                    <div class="form-group">
                        <label for="username">Company</label>
                        <input type="text" id="last_name" name="company_name" class="form-control" formControlName="str_company">
                        <span class="error_message" *ngIf="err.str_company">{{err.str_company}}</span>
                    </div>
                    <div class="form-group">
                        <label for="username">Email</label>
                        <input type="text" id="email" name="email" class="form-control" formControlName="str_email">
                        <span class="error_message" *ngIf="err.str_email">{{err.str_email}}</span>
                    </div>
                    <div class="form-group">
                        <label for="username">Assign Projects</label>
						<span class="error_message" *ngIf="err.txt_projects">{{err.txt_projects}}</span>
						<div *ngFor="let row of projects; let i = index;">
						<input name="txt_projects" [checked]="assign_projects[row.id].selected" (click)="select_project($event)" type="checkbox" formControlName="txt_projects" value="{{row.id}}"> {{row.name}}
						<div class="last-mention" *ngIf="assign_projects[row.id].selected">
                        <!--cat switch-->
							<div class="categories_switch">
								<a class="">
									<div class="results_type"><i class="fa fa-globe"></i><p>All</p>
										<input data-id="{{row.id}}" [checked]="assign_projects[row.id].all" type="checkbox" value="all" (click)="sm_checkbox_event($event)">
									</div>
								</a>
								<a class="">
									<div class="results_type"><i class="fa fa-share-alt"></i><p>Web</p>
										<input data-id="{{row.id}}" [checked]="assign_projects[row.id].web" type="checkbox" value="web" (click)="sm_checkbox_event($event)"></div>
								</a>
								<a class="">
									<div class="results_type"><i class="fa fa-twitter"></i><p>Twitter</p>
										<input data-id="{{row.id}}" [checked]="assign_projects[row.id].twitter" type="checkbox" value="twitter" (click)="sm_checkbox_event($event)"></div>
								</a>
								<a class="">
									<div class="results_type"><i class="fa fa-facebook"></i><p>Facebook</p>
										<input data-id="{{row.id}}" [checked]="assign_projects[row.id].facebook" type="checkbox" value="facebook" (click)="sm_checkbox_event($event)"></div>
								</a>
								<a class="">
									<div class="results_type"><i class="fa fa-play"></i><p>Youtube</p>
										<input data-id="{{row.id}}" [checked]="assign_projects[row.id].youtube" type="checkbox" value="youtube" (click)="sm_checkbox_event($event)"></div>
								</a>
								<a class="">
									<div class="results_type"><i class="fa fa-instagram"></i><p>Instagram</p>
										<input data-id="{{row.id}}" [checked]="assign_projects[row.id].instagram" type="checkbox" value="instagram" (click)="sm_checkbox_event($event)"></div>
								</a>
								<a class="">
									<div class="results_type"><i class="fa fa-comment"></i><p>Reviews</p>
										<input data-id="{{row.id}}" [checked]="assign_projects[row.id].reviews" type="checkbox" value="reviews" (click)="sm_checkbox_event($event)"></div>
								</a>
								<a class="">
									<div class="results_type"><i class="fa fa-rss"></i><p>Others</p>
										<input data-id="{{row.id}}" [checked]="assign_projects[row.id].others" type="checkbox" value="others" (click)="sm_checkbox_event($event)"></div>
								</a>
							</div>
							<span class="error_message" *ngIf="err.txt_channels">{{err.txt_channels}}</span>
						</div>
						</div>
                    </div>
                    
                    <div class="form-group btn-up">
                        <button class="panel_save_btn">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="rgb(199, 28, 109)" type="square-loader" [fullScreen]="true"></ngx-spinner>
